import clsx from "classnames";

export default function Component(props) {
  return (
    <div
      className={clsx("tab-pane fade show", {
        "active": props?.active
      })}
      id={props?.id}
      role="tabpanel"
      aria-labelledby={`${props?.id}-tab`}
      tabIndex="0"
    >
      <div className="position-relative w-100 bg-light-primary border-primary2 shadow-sm rounded-4 p-4">
        {props?.children}
      </div>
    </div>
  );
};